import { Georadar } from '@node/wam-audience-builder'
const papa = require('papaparse')

/**
 *
 * @param {Object} file
 * @param {Function} errorCallBack
 * @returns {Boolean}
 */
export const isCsvFile = file => {
    return file && file.name.match(/\.csv$/) ? true : false
}

export const parseGeoradarCSV = async file => {
    const DELIMITER = ';'
    const MAX_ROW_COUNT = 500
    const VALID_HEADER = 'label;latitude;longitude;radius'
    const points = await parseCSV(file, {
        delimiter: DELIMITER,
        header: true,
        dynamicTyping: true,
        preview: MAX_ROW_COUNT + 1,
        skipEmptyLines: true
    })

    if (points.length === 0) {
        throw new Error('The input file is empty')
    } else if (Object.keys(points[0]).join(';') !== VALID_HEADER) {
        throw new Error('Your csv format is not valid')
    } else if (points.length > MAX_ROW_COUNT) {
        throw new Error(`Your csv cannot exceed ${MAX_ROW_COUNT} rows.`)
    }

    return points
}

const parseCSV = (file, options = {}) => {
    return new Promise((resolve, reject) => {
        papa.parse(file, {
            ...options,
            complete: results => {
                resolve(results.data)
            },
            error: err => {
                reject(err)
            }
        })
    })
}

export const unparseGeoradarCSV = json => {
    return papa.unparse(json, { delimiter: ';' })
}

export const parseData = data =>
    data.map(item => ({
        ...item,
        jsonKey: {
            name: `georadar_${item.label}_${item.id}`,
            type: 'GeoradarID',
            subType: 'georadar',
            ids: [item.id]
        },
        parentJsonKeyName: null,
        isSelectable: true
    }))

export const unParseData = data =>
    data.map(item => ({
        id: item.id,
        label: item.label,
        longitude: item.longitude,
        latitude: item.latitude,
        radius: item.radius
    }))

/**
 * Add new points, set updated points and destroy deleted points
 * in the right source
 * @param {Object}      state - Vuex state
 * @param {Object}      payload
 * @param {String}      payload.source list where the merge is made
 * @param {Object[]}    payload.points array of points that have been updated
 */
export const mergePoints = (commit, { source, points }) => {
    // Group points by action
    const groupedPoints = points.reduce(
        (acc, p) => {
            acc[p.action] = [...acc[p.action], p]
            return acc
        },
        { create: [], update: [], delete: [] }
    )

    // Mapper to interface right mutation with source and type of action
    const _mutations = {
        savedPoints: {
            create(pts) {
                commit('addPoints', { points: pts })
            },
            update(pts) {
                commit('updatePoints', { points: pts })
            },
            delete(pts) {
                commit('deletePoints', { points: pts })
            }
        },
        unSavedPoints: {
            create(pts) {
                commit('addNewPoints', { points: pts })
            },
            update(pts) {
                commit('setPoints', { points: pts })
            }
        }
    }

    // Handle right mutation by source and type of action
    Object.entries(groupedPoints).forEach(([typeOfChange, groupOfPoints]) => {
        if (groupOfPoints.length > 0) {
            _mutations[source][typeOfChange](groupOfPoints)
        }
    })
}

/**
 * It truncates georadar coordinates because we don't want them to exceed 6 characters
 * @param {String|Number} coordinate
 * @returns {String}
 */
export const truncateCoordinate = coordinate => {
    const val = coordinate?.toString()
    if (val && val.includes('.') && val.split('.')[1].length > 6) {
        return val.slice(0, val.indexOf('.') + 7)
    }
    return val
}

/**
 * Instanciate all georadar points
 * @param {Object} georadarPoint
 * @returns {Array}
 */
export const instanciateAll = georadarPoint => {
    return Georadar.createAll(
        georadarPoint
            .filter(point => point.status === 'active')
            .map(point => {
                return {
                    id: parseFloat(point.id),
                    label: point.label,
                    path: ['Geography', 'Georadar'],
                    selectable: true,
                    displayId: true
                }
            })
    )
}
